import React, { useState } from 'react';
import { Button, Card, Typography, message } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { axiosInstance } from '../config';

const downloadJson = (payload, filename) => {
    const blob = new Blob([JSON.stringify(payload, null, 2)], {
        type: 'application/json;charset=utf-8',
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
};

const ReviewAiLearn = () => {
    const [loading, setLoading] = useState(false);

    const exportAnswered = async () => {
        setLoading(true);
        try {
            const { data } = await axiosInstance.get('/v1/reviews/ai-learn/export', {
                timeout: 120000,
            });
            const items = Array.isArray(data?.items) ? data.items : [];
            if (!items.length) {
                message.warning('Нет отзывов с ответами для выгрузки');
                return;
            }
            const stamp = new Date().toISOString().slice(0, 10);
            downloadJson(data, `reviews-ai-learn-${stamp}.json`);
            message.success(`Выгружено отзывов: ${items.length}`);
        } catch (error) {
            message.error(
                error.response?.data?.detail || 'Не удалось сформировать выгрузку'
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mx-auto">
            <Card>
                <Typography.Title level={2} style={{ margin: 0 }}>
                    AI Learn
                </Typography.Title>
                <Typography.Paragraph type="secondary" className="mt-2 mb-4">
                    Выгрузка отзывов, на которые уже есть ответы, в JSON для обучения.
                </Typography.Paragraph>
                <Button
                    type="primary"
                    icon={<DownloadOutlined />}
                    loading={loading}
                    onClick={exportAnswered}
                >
                    Выгрузить отзывы с ответами
                </Button>
            </Card>
        </div>
    );
};

export default ReviewAiLearn;
